import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const MaintenanceCardsState = Immutable.fromJS({

   mCardListViewModel :{
      caseModel: {},
      cardsModel: [],
      statistis:{
        total:0,
        complete:0
      },
      sortOrders: { 
        orderby: undefined,
        code: { by: "code", asc: undefined }, 
        status: { by: "status", asc: undefined }, 
        owner: { by: "owner", asc: undefined }, 
        unit: { by: "unit", asc: undefined } },
   },

   mCardListRequestModel :{
      target: '',
      filter: '',
   },

   alert: {
      alertStyle: null,
      alertMessage: null,
   },

});

const maintenanceCardsReducer = handleActions({
  SET_CARDS_FILTER_STRING: (state, { payload }) => {
    return state.updateIn(['mCardListRequestModel', 'filter'], () => payload).merge()
  },

	EVALUATE_MAINTENANCE_STATISTIC: (state, { payload }) => {
    let modelObj = state.get('mCardListViewModel');
   return state.merge({
			mCardListViewModel : modelObj.set('statistis' , payload.data)
		})
  },

	RELOAD_MAINTENANCE_CASE: (state, { payload }) => {
    let modelObj = state.get('mCardListViewModel');
   return state.merge({
			mCardListViewModel : modelObj.set('caseModel' , payload.data)
		})
  },

	FIND_MAINTENANCE_CARDS_BY_FK: (state, { payload }) => {
    let modelObj = state.get('mCardListViewModel');
    return state.merge({
      mCardListViewModel: modelObj.set('cardsModel', payload.data)
    })
  },

	SET_MAINTENANCE_CARDS: (state, { payload }) => {
    state = state.updateIn(['mCardListViewModel', 'cardsModel'], (value) => payload );
    state = state.updateIn(['mCardListRequestModel', 'filter'], (value) => '' );
    return state.merge();
  },

  SORT_CARDS_BY_FIELD: (state, { payload }) => {
    state = state.updateIn(['mCardListViewModel', 'sortOrders', payload.order.get('by'), 'asc'], 
    value => value == undefined ? false : !value);
    state = state.updateIn(['mCardListViewModel', 'cardsModel'], () => payload.cards);
    state = state.updateIn(['mCardListViewModel', 'sortOrders', 'orderby'], () => payload.order.get('by'));

    return state.merge();
  },

  SET_MAINTENANCE_TARGET_CARD: (state, { payload }) => {
    let request = state.get('mCardListRequestModel');
    return state.merge({
      mCardListRequestModel: request.set('target', payload.cardId)
    })
  },

  CLEAN_MAINTENANCE_CARDS_ALERT :(state, { payload }) => {

    return state.merge({
      alert:{
        alertStyle: null,
        alertMessage: null,
      }
    })
  },  

}, MaintenanceCardsState);

export default maintenanceCardsReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceCardsReducer.js